const locationPickerTreeActions = {}

locationPickerTreeActions.actionsTypes = {
  SET_EXPAND_NODE: '{LOCATION_PICKER_TREE} Set Expand Node',
  SET_PROPERTY_EXPAND_NODE: '{LOCATION_PICKER_TREE} Set Property Expand Node',
  SET_PROPERTY_CHECK_NODE: '{LOCATION_PICKER_TREE} Set Property Check Node',
  SET_CHECK_NODE: '{LOCATION_PICKER_TREE} Set Check Node',
  SELECT_ALL: '{LOCATION_PICKER_TREE} Select All',
  SET_SELECT_ALL_STATE: '{LOCATION_PICKER_TREE} Set Select All State',
  LOAD_NODES_SUCCESS: '{LOCATION_PICKER_TREE} Load Nodes Success',
  RESET_TREE_COPY_STATE: '{LOCATION_PICKER_TREE} Reset Tree State',
}

locationPickerTreeActions.setExpandNode = (key, propertyId) => ({
  type: locationPickerTreeActions.actionsTypes.SET_EXPAND_NODE,
  payload: { key, propertyId },
})

locationPickerTreeActions.setPropertyExpandNode = (key) => ({
  type: locationPickerTreeActions.actionsTypes.SET_PROPERTY_EXPAND_NODE,
  payload: { key },
})

locationPickerTreeActions.setPropertyCheckNode = (key, bool) => ({
  type: locationPickerTreeActions.actionsTypes.SET_PROPERTY_CHECK_NODE,
  payload: { key, bool },
})

locationPickerTreeActions.setCheckNode = (
  key,
  bool,
  mainLevel,
  propertyId
) => ({
  type: locationPickerTreeActions.actionsTypes.SET_CHECK_NODE,
  payload: { key, bool, mainLevel, propertyId },
})

locationPickerTreeActions.selectAll = (isSelectAll) => ({
  type: locationPickerTreeActions.actionsTypes.SELECT_ALL,
  payload: { isSelectAll },
})

locationPickerTreeActions.setSelectAllState = () => ({
  type: locationPickerTreeActions.actionsTypes.SET_SELECT_ALL_STATE,
})

locationPickerTreeActions.loadNodesSucceeded = (
  treeRoot,
  allowedLocationIds
) => ({
  type: locationPickerTreeActions.actionsTypes.LOAD_NODES_SUCCESS,
  payload: { treeRoot, allowedLocationIds },
})

locationPickerTreeActions.resetTreeState = () => ({
  type: locationPickerTreeActions.actionsTypes.RESET_TREE_COPY_STATE,
})

export default locationPickerTreeActions
